/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React, { useState } from "react";
import '../../Styles/styles.BaselineChart.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {mapDataForHighchartsGroupedBar} from "../../mappers/model/GroupedBarChartMapper"
import BarChart from "../Charts/BarChart.jsx"

var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };

const MAX_PLAYERS_PER_CHART = 12;

export function BaselineChart({dataIn, teamColors, home_page, dataColorUtil}) {
    const [hiddenMetrics, setHiddenMetrics] = useState([]);

    const players = dataIn.data;
    const chartCount = Math.max(1, Math.ceil(players.length / MAX_PLAYERS_PER_CHART));
    const playersPerChart = Math.ceil(players.length / chartCount);

    const toggleMetric = (name) => setHiddenMetrics((hidden) =>
        hidden.includes(name) ? hidden.filter((n) => n !== name) : [...hidden, name]
    );

    // The charts are one chart split for space: the first chart shows the
    // legend, and a legend click hides the metric in every chart.
    const charts = Array.from({length: chartCount}, (_, index) => {
        const options = mapDataForHighchartsGroupedBar({
            dataIn: {data: players.slice(index * playersPerChart, (index + 1) * playersPerChart)},
            metrics: dataIn?.metrics ?? [],
            teamColors: teamColors.all,
            isTeamChart: true,
            isComparison: false,
            dataColorUtil
        });
        const sharedOptions = options && {
            ...options,
            legend: {...options.legend, enabled: index === 0},
            series: options.series.map((s) => ({...s, visible: !hiddenMetrics.includes(s.name)})),
            plotOptions: {
                ...options.plotOptions,
                series: {
                    ...options.plotOptions?.series,
                    events: {
                        legendItemClick: function (event) {
                            event.preventDefault();
                            toggleMetric(this.name);
                        }
                    }
                }
            }
        };
        return (
            <div className="exportable breakdown-chart width-90" key={index}>
                <BarChart options={sharedOptions} height={'inherit'}/>
            </div>
        );
    });

    if (home_page === true) {
        return (
            <div className="features-content-breakdown">
                <div className="outer-slider-breakdown">
                    <Slider {...settings}>
                        {charts.map((chart, index) => <div key={index}>{chart}</div>)}
                    </Slider>
                </div>
            </div>
        );
    }

    return <div className='baselinechart-chart-grid'>{charts}</div>;
}
